import { cn, Sparkline } from '@up2stay/up2promo-ui';

export type ProductScanSparklineProps = {
  series: Array<{ date: string; count: number }>;
  className?: string;
};

/** Tiny real scan series — no decorative fake data. */
export function ProductScanSparkline({
  series,
  className,
}: ProductScanSparklineProps) {
  if (series.length < 2) return null;
  return (
    <Sparkline
      values={series.map((point) => point.count)}
      className={cn(
        'h-7 w-full max-w-[7.5rem] text-muted-foreground opacity-70',
        className,
      )}
    />
  );
}
